import React from 'react'
import './index.scss'

const Footer = ({ goTo }) => (
  <footer className='footerLayout'>
    <div className='footerLayoutBox'>
      <div className='footerCopi'>
        © 2022, All right reserved
      </div>

      <div>
        <span onClick={() => goTo('/terms')} className='footerLinkTerms'>Terms of Use</span>

        <span onClick={() => goTo('/privacy')} className='footerLink'>Privacy Policy</span>
      </div>
    </div>
  </footer>
)

export default Footer
